module.exports = __webpack_public_path__ + "img/132.c3190047.jpg";